import { log } from "console";
import { fetch as http } from "./http";

export const createReminderService = async (payload: any) => {
  try {
    const data = await http.Post("/reminders", payload);
    payload?.callback && payload?.callback(false, data);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true, error);
    delete payload?.callback;
    throw new Error(error);
  }
};

export const fetchRemindersService = async () => {
  try {
    const data = await http.Get("/reminders");
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchReminderByIdService = async (id: string) => {
  try {
    console.log("Fetching reminder by ID:", id);
    const data = await http.Get(`/reminders/${id}`);
    console.log("Reminder detail API response:", data);
    return data;
  } catch (error: any) {
    console.error("Error in fetchReminderByIdService:", error);
    throw new Error(error);
  }
};

// export const fetchReminderCalendarService = async (
//   startDate?: string,
//   endDate?: string,
//   searchTerm?: string,
//   reminderType?: string,
//   status?: string,
//   userId?: string | number | (string | number)[] | undefined,
//   sortBy?: "created_at" | "remind_on",
//   sortOrder?: "asc" | "desc"
// ) => {
//   try {
//     // Build query parameters
//     const params = new URLSearchParams();

//     // Only add date parameters if they are provided
//     if (startDate && endDate) {
//       params.append("start_date", startDate);
//       params.append("end_date", endDate);
//     }

//     // console.log(
//     //   params,
//     //   "inside fetchReminderCalendarService  fetchReminderCalendarService"
//     // );
//     if (searchTerm && searchTerm.trim()) {
//       params.append("search", searchTerm.trim());
//     }

//     if (reminderType && reminderType !== "all") {
//       params.append("reminder_type", reminderType);
//     }

//     if (status && status !== "all") {
//       params.append("status", status);
//     }

//     // Optional user filter (agent) - support single or array
//     if (Array.isArray(userId)) {
//       const ids = userId.map((v) => `${v}`.trim()).filter((v) => v !== "");
//       if (ids.length > 0) {
//         // Send as comma list (backend can decode to array)
//         params.append("user_id", ids.join(","));
//       }
//     } else if (
//       userId !== undefined &&
//       userId !== null &&
//       `${userId}`.trim() !== ""
//     ) {
//       params.append("user_id", `${userId}`);
//     }

//     // Optional sorting
//     if (sortBy) params.append("sort_by", sortBy);
//     if (sortOrder) params.append("sort_order", sortOrder);

//     // alert(`${params.toString()} `);
//     const url = `/reminders/calendar?${params.toString()}`;
//     console.log("Making API call to:", url);
//     const data = await http.Get(url);
//     console.log("API response received:", data);

//     // Normalize various possible response shapes into an array of events
//     let events: any[] = [];

//     // Case 1: API returned an array directly
//     if (Array.isArray(data)) {
//       events = data;
//     }
//     // Case 2: { status: true, result: [...] }
//     else if (data && Array.isArray((data as any)?.result)) {
//       events = (data as any).result as any[];
//     }
//     // Case 3: { status: true, result: { "0": {...}, "1": {...} } }
//     else if (
//       data &&
//       (data as any)?.result &&
//       typeof (data as any).result === "object" &&
//       !Array.isArray((data as any).result)
//     ) {
//       const obj = (data as any).result;
//       events = Object.values(obj);
//     }
//     // Case 4: Nested data under result.data
//     else if (
//       data &&
//       (data as any)?.result &&
//       Array.isArray((data as any)?.result?.data)
//     ) {
//       events = (data as any).result.data as any[];
//     }

//     if (!Array.isArray(events)) {
//       console.warn(
//         "fetchReminderCalendarService: Unexpected response shape; returning empty list"
//       );
//       events = [];
//     }

//     return events;
//   } catch (error: any) {
//     console.error("API call failed:", error);
//     throw new Error(error);
//   }
// };
export const fetchReminderCalendarService = async (
  startDate?: string,
  endDate?: string,
  searchTerm?: string,
  reminderType?: string,
  status?: string,
  userId?: string | number | (string | number)[] | undefined,
  sortBy?: "created_at" | "remind_on",
  sortOrder?: "asc" | "desc"
) => {
  try {
    // Build query string manually to allow literal commas
    let query = "";

    // Date filters
    if (startDate && endDate) {
      query += `start_date=${startDate}&end_date=${endDate}&`;
    }

    // Search term
    if (searchTerm?.trim()) {
      query += `search=${encodeURIComponent(searchTerm.trim())}&`;
    }

    // Reminder type
    if (reminderType && reminderType !== "all") {
      query += `reminder_type=${encodeURIComponent(reminderType)}&`;
    }

    // Status
    if (status && status !== "all") {
      query += `status=${encodeURIComponent(status)}&`;
    }

    // User ID filter
    if (Array.isArray(userId) && userId.length > 0) {
      const ids = userId.map((v) => `${v}`.trim()).filter((v) => v !== "");
      if (ids.length > 0) {
        query += `user_id=${ids.join(",")}&`; // <-- literal comma
      }
    } else if (
      userId !== undefined &&
      userId !== null &&
      `${userId}`.trim() !== ""
    ) {
      query += `user_id=${userId}&`;
    }

    // Sorting
    if (sortBy) query += `sort_by=${sortBy}&`;
    if (sortOrder) query += `sort_order=${sortOrder}&`;

    // Remove trailing &
    query = query.replace(/&$/, "");

    const url = `/reminders/calendar?${query}`;
    console.log("Making API call to:", url);

    // Make the API GET request
    const data = await http.Get(url);
    console.log("API response received:", data);

    // Normalize API response to array of events
    let events: any[] = [];

    if (Array.isArray(data)) {
      events = data;
    } else if (data && Array.isArray((data as any)?.result)) {
      events = (data as any).result as any[];
    } else if (
      data &&
      (data as any)?.result &&
      typeof (data as any).result === "object" &&
      !Array.isArray((data as any).result)
    ) {
      events = Object.values((data as any).result);
    } else if (
      data &&
      (data as any)?.result &&
      Array.isArray((data as any)?.result?.data)
    ) {
      events = (data as any).result.data as any[];
    }

    if (!Array.isArray(events)) {
      console.warn(
        "fetchReminderCalendarService: Unexpected response shape; returning empty list"
      );
      events = [];
    }

    return events;
  } catch (error: any) {
    console.error("API call failed:", error);
    throw new Error(error);
  }
};

export const updateReminderService = async (
  reminderId: string,
  payload: any
) => {
  try {
    // Structure the payload to match the API format
    const updateData = {
      query_id: payload.query_id || payload.query,
      title: payload.title,
      description: payload.description,
      assigned_to: payload.assigned_to || payload.assignedTo,
      remind_on: payload.remind_on || payload.remindOn,
      remind_before_minutes:
        payload.remind_before_minutes || payload.reminderBeforeMinutes,
      reminder_type: payload.reminder_type || payload.reminderType,
    };

    const data = await http.Put(`/reminders/${reminderId}`, updateData);
    payload?.callback && payload?.callback(false, data);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true, error);
    throw new Error(error);
  }
};

export const deleteReminderService = async (id: string) => {
  try {
    const data = await http.Delete(`/reminders/${id}`);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const completeReminderService = async (payload: any) => {
  try {
    const data = await http.Post(`/reminders/${payload.id}/complete`, {
      completion_remarks: payload.completion_remarks,
    });
    payload?.callback && payload?.callback(false, data);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true, error);
    delete payload?.callback;
    throw new Error(error);
  }
};

export const snoozeReminderService = async (payload: any) => {
  try {
    const data = await http.Post(`/reminders/${payload.id}/snooze`, {
      snooze_minutes: payload.snooze_minutes,
    });
    payload?.callback && payload?.callback(false, data);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true, error);
    delete payload?.callback;
    throw new Error(error);
  }
};

// Get reminder activity logs
export const getReminderActivityLogs = async (id: string) => {
  try {
    const response = await http.Get(`/reminders/${id}/activity-logs`);

    console.log("Reminder activity logs response:", response);

    return response.result || response.data || [];
  } catch (error) {
    console.error("Error fetching reminder activity logs:", error);
    throw error;
  }
};

// Fetch reminders queue (past/upcoming/total) with optional query params
export const fetchRemindersQueueService = async (params: any = {}) => {
  try {
    let url = "/reminders/queue";
    if (params && Object.keys(params).length) {
      const q = new URLSearchParams(params as any).toString();
      url = `${url}?${q}`;
    }

    const resp = await http.Get(url);
    // Return the raw response so callers can inspect total/past/upcoming groups
    return resp;
  } catch (error: any) {
    console.error("fetchRemindersQueueService error:", error);
    throw error;
  }
};

export const fetchQueriesService = async (params: any = {}) => {
  try {
    let url = "/queries/get/list";
    if (params && Object.keys(params).length) {
      const query = new URLSearchParams(params as any).toString();
      url = `${url}?${query}`;
    }
    const resp = await http.Get(url);
    return resp;
  } catch (err) {
    throw err;
  }
};

export const exportRemindersService = async (params: {
  from_date?: string;
  to_date?: string;
  user_id?: string | number | null;
  token?: string | null;
  absoluteUrl?: string | null;
}) => {
  try {
    const { from_date, to_date, user_id, token, absoluteUrl } = params as any;
    let url = "";
    if (absoluteUrl) {
      url = `${absoluteUrl}?from_date=${from_date}&to_date=${to_date}${
        user_id ? `&user_id=${user_id}` : ""
      }`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        } as any,
      });
      if (!res.ok)
        throw new Error(`Export failed: ${res.status} ${res.statusText}`);

      const contentType = (res.headers.get("content-type") || "").toLowerCase();

      if (
        contentType.includes("application/json") ||
        contentType.includes("text/json") ||
        contentType.includes("text/plain")
      ) {
        // Attempt to parse JSON safely even if content-type is text/plain
        const text = await res.clone().text();
        try {
          const json = JSON.parse(text);
          return {
            shareable_link:
              json?.result?.shareable_link || json?.shareable_link || null,
            filename: json?.result?.filename || json?.filename || null,
          } as any;
        } catch (err) {
          // Not JSON - fall through to blob handling
        }
      }

      // Fall back to treating response as binary
      const blob = await res.blob();
      return { blob, filename: res.headers.get("content-disposition") };
    }

    // Use internal http helper which uses baseUrl and token from store
    const query = `from_date=${from_date}&to_date=${to_date}${
      user_id ? `&user_id=${user_id}` : ""
    }`;
    const data = await http.ExportGet(
      `/reminders/export?${query}`,
      token as any
    );

    try {
      if (data && typeof (data as any).text === "function") {
        const text = await (data as Blob).text();
        console.log("exportRemindersService - blob text:", text);
        try {
          const json = JSON.parse(text);
          if (json?.result?.shareable_link || json?.shareable_link) {
            return {
              shareable_link:
                json?.result?.shareable_link || json?.shareable_link || null,
              filename: json?.result?.filename || json?.filename || null,
            } as any;
          }
        } catch (err) {
          console.log("exportRemindersService - blob is not JSON");
        }
      }
    } catch (err) {
      console.log("exportRemindersService - error while parsing blob:", err);
    }

    return { blob: data, filename: null };
  } catch (error: any) {
    console.error("exportRemindersService error:", error);
    throw error;
  }
};
